import React, { useEffect, useState } from 'react';
import {
  Box,
  Modal,
  ModalFooter,
  Button,
  ModalBody,
  Text,
  Grid,
  Spacer,
  Select,
} from '@flexisaf/flexibull2';
import {
  selectCurrentApplication,
  selectCurrentApplicationLoading,
} from 'redux/applications/selectors';
import { fetchSingleApplication } from 'redux/applications/actions';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import TextAlias from 'components/TextAlias';
import Theme from 'utils/theme';

export const ChangeCourseModal = (props) => {
  const dispatch = useDispatch();
  const currentApplication = useSelector(selectCurrentApplication);
  const loadingApplication = useSelector(selectCurrentApplicationLoading);

  const [selectedCourse, setSelectedCourse] = useState(null);

  useEffect(() => {
    if (props?.applicant?.course) {
      setSelectedCourse({
        label: props.applicant.course.title,
        value: props.applicant.course.id,
      });
    }
  }, [props.applicant]);

  useEffect(() => {
    if (currentApplication?.id !== props?.application?.id) {
      dispatch(fetchSingleApplication(props?.application?.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, props.applicant]);

  return (
    <>
      <Modal open={props.open}>
        <ModalBody width="500px">
          <Box pad="50px 40px">
            <Text block size="25px">
              Change Applicant <TextAlias>Course</TextAlias>
            </Text>
            <Box margin="35px 0 0">
              <Text size="14px" block bold>
                Current <TextAlias>Course</TextAlias> Information
              </Text>
              <Spacer space="15px" />
              <Box margin="0 0 30px" width="100%">
                <Grid default="1fr 1fr" gap="40px">
                  <Grid default="1fr" gap="15px">
                    <Text bold block uppercase>
                      <TextAlias>Course</TextAlias>
                    </Text>
                    <Text block uppercase>
                      {props.applicant?.course?.title}
                    </Text>
                  </Grid>
                  <Grid default="1fr" gap="15px">
                    <Text bold block uppercase>
                      <TextAlias>Course</TextAlias> Code
                    </Text>
                    <Text block uppercase>
                      {props.applicant?.course?.code}
                    </Text>
                  </Grid>
                </Grid>
              </Box>
              {loadingApplication ? (
                <SkeletonTheme>
                  <Skeleton count={1} height={50} />
                </SkeletonTheme>
              ) : (
                <Select
                  style={{ width: '100%' }}
                  spaceTop="25px"
                  spaceBottom="25px"
                  label="Select new Course"
                  options={currentApplication?.courses?.map((c) => ({
                    label: c?.course?.title,
                    value: c?.course?.id,
                  }))}
                  onChange={setSelectedCourse}
                  value={selectedCourse}
                />
              )}
            </Box>
          </Box>
          <ModalFooter>
            <Box width="fit-content" margin="0 0 0 auto" pad="30px 40px">
              <Button
                height={42}
                pale
                fontColor={Theme.PrimaryRed}
                color="transparent"
                spaceRight
                spaceLeft="auto"
                onClick={() => props.close()}
              >
                cancel
              </Button>
              <Button
                height={42}
                spaceLeft
                disabled={props.applicant?.course?.id === selectedCourse?.value}
                onClick={() =>
                  props.onChange(props.applicant?.id, selectedCourse?.value)
                }
                progress={props.changingCourse}
              >
                Change Course
              </Button>
            </Box>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </>
  );
};

ChangeCourseModal.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  applicant: PropTypes.object,
  application: PropTypes.object,
  onChange: PropTypes.func,
  changingCourse: PropTypes.bool,
};
